import React from 'react';
import _ from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


import ParkerAccessDevice from '../../Entities/ParkerAccessDevice';
import ParkerAccessDeviceTableRow from './ParkerAccessDeviceTableRow';

import './ParkerAccessDeviceTable.scss';

export default function ParkerAccessDeviceTable(props) {
  const {
    accessDevices,
    allowAdd,
    allowRemove,
    editMode,
    fieldConfiguration,
    onChange,
    showInactiveDevices,
  } = props;

  const _onAccessDeviceChange = ident => {
    return accessDevice => {
      const accessDevices = _.cloneDeep(props.accessDevices);

      if (ident === null) {
        accessDevice.newDevice = true
        accessDevices.push(accessDevice);
      }
      else if (accessDevice === null) {
        accessDevices.splice(ident, 1);
      }
      else {
        accessDevices[ident] = accessDevice;
      }
      onChange(accessDevices);
    };
  }

  const onAddAccessDeviceClick = () => {
    _onAccessDeviceChange(null)(new ParkerAccessDevice());
  }



  const activeDevices = [];
  const inactiveDevices = [];
  const newDevices = [];

  accessDevices.forEach((accessDevice, index) => {
    // Need to keep track of the array index value saved in the database for accurate updating
    accessDevice.dbIndex = index;
    if (!accessDevice.newDevice) {
      if (accessDevice.fields.device_status.value === 'ACTIVE') {
        activeDevices.push(accessDevice);
      } else if (accessDevice.fields.device_status.value === 'INACTIVE') {
        inactiveDevices.push(accessDevice);
      }
    } else {
      newDevices.push(accessDevice);
    }
  });

  const devicesToShow = [...activeDevices];
  if (showInactiveDevices) devicesToShow.push(...inactiveDevices);
  // Keep new devices listed last regardless of inactive devices showing or not
  devicesToShow.push(...newDevices);

  return (
    <>
      <TableContainer
        component={Paper}
        className="parkeraccessdevice--table-container"
      >
        <Table
          className="parkeraccessdevice--table"
          aria-label="customized table"
        >
          <TableHead className="parkeraccessdevice--table-thead">
            <TableRow>
              <TableCell>Device Type</TableCell>
              <TableCell>Device ID</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Date Added</TableCell>
              <TableCell>Active Date</TableCell>
              <TableCell>Inactive Date</TableCell>
              <TableCell>Reason</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="parkeraccessdevice-active--table-tbody">
            {devicesToShow.map((accessDevice, index) => (
              <ParkerAccessDeviceTableRow
                key={index}
                accessDevice={accessDevice}
                allowRemove={allowRemove}
                editMode={editMode}
                fieldConfiguration={fieldConfiguration}
                ident={index}
                onAccessDeviceChange={_onAccessDeviceChange(accessDevice.dbIndex)}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {allowAdd && (
        <button
          type="button"
          className="parkchirp--button-as-link parkeraccessdevice--button-add_device"
          onClick={onAddAccessDeviceClick}
        >
          Add Access Device
        </button>
      )}
    </>
  );
}
